(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[431],{

/***/ 57966:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[...dynamic-slug]",
      function () {
        return __webpack_require__(20080);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 59249:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_Avatar; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(57389);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(43119);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(11527);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.1.1_7i5myeigehqah43i5u7wbekgba/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(61258);
;// CONCATENATED MODULE: ./workspaces/app/static/main/src/services/utils/propValidators.js
/* eslint-disable import/prefer-default-export */ function numberInRange(param) {
    var props = param.props, propName = param.propName, componentName = param.componentName, isRequired = param.isRequired, rangeStart = param.rangeStart, rangeEnd = param.rangeEnd;
    if (typeof rangeStart !== "number" || typeof rangeEnd !== "number" || rangeStart >= rangeEnd) {
        return new Error("Invalid rangeStart or rangeEnd is passed to ".concat(componentName, " ").concat(propName, " prop validator"));
    }
    var value = props && props[propName];
    if (isRequired && !value && value !== 0) {
        return new Error("Invalid prop ".concat(propName, " is supplied to ").concat(componentName, ". ").concat(propName, " is required"));
    }
    if (value && typeof value !== "number") {
        return new Error("Invalid prop ".concat(propName, " is supplied to ").concat(componentName, ". ").concat(propName, " should be a number"));
    }
    if (value < rangeStart || value > rangeEnd) {
        return new Error("Invalid prop ".concat(propName, " is supplied to ").concat(componentName, ". ").concat(propName, " is not in ").concat(rangeStart, " to ").concat(rangeEnd, " range"));
    }
    return null;
}

;// CONCATENATED MODULE: ./workspaces/app/static/main/src/components/Avatar/index.tsx
// Similar to https://material-ui.com/components/avatars/


function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n			background-color: ",
        ";\n		"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	width: ",
        "px;\n	height: ",
        "px;\n	position: relative;\n	border-radius: ",
        ";\n	color: ",
        ";\n	background-color: ",
        ";\n	font-weight: ",
        ";\n	font-size: 20px;\n\n	",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	width: 100%;\n	height: 100%;\n	border-radius: ",
        ";\n	overflow: hidden;\n	text-align: center;\n	display: flex;\n	justify-content: center;\n	align-items: center;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	width: 100%;\n	height: 100%;\n	position: absolute;\n	top: 0;\n	left: 0;\n	object-fit: ",
        ";\n	padding: ",
        ";\n	border-radius: ",
        ";\n	filter: ",
        ";\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	width: ",
        "px;\n	height: ",
        "px;\n	position: relative;\n	border-radius: 50%;\n	overflow: hidden;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}




var SHAPES = {
    CIRCLE: "circle",
    SQUARE: "square"
};
var _obj;
var shapeRadiusMap = (_obj = {}, (0,_define_property/* default */.Z)(_obj, SHAPES.CIRCLE, "50%"), (0,_define_property/* default */.Z)(_obj, SHAPES.SQUARE, "5%"), _obj);
var Wrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-1673965b-0"
}).withConfig({
    componentId: "sc-ac4e0f43-0"
})(_templateObject1(), function(props) {
    return props.size;
}, function(props) {
    return props.size;
}, function(props) {
    return shapeRadiusMap[props.shape] || "50%";
}, function(props) {
    return props.theme.colors.text.main;
}, function(props) {
    return !props.hasImage && props.theme.colors.grey[200];
}, function(props) {
    return props.theme.text.fontWeightSemiBold;
}, function(param) {
    var bgColor = param.bgColor;
    return bgColor && (0,styled_components_browser_esm/* css */.iv)(_templateObject(), bgColor);
});
var InnerCircle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-1673965b-1"
}).withConfig({
    componentId: "sc-ac4e0f43-1"
})(_templateObject2(), function(props) {
    return shapeRadiusMap[props.shape] || "50%";
});
var Image = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
    componentId: "sc-1673965b-2"
}).withConfig({
    componentId: "sc-ac4e0f43-2"
})(_templateObject3(), function(props) {
    return props.imageScaleDown ? "scale-down" : "cover";
}, function(props) {
    return props.imageScaleDown && props.imagePadding;
}, function(props) {
    return props.disableImageShape ? "0%" : shapeRadiusMap[props.shape] || "50%";
}, function(props) {
    return props.brightness && "brightness(".concat(props.brightness, ")");
});
var NextImageWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-1673965b-3"
}).withConfig({
    componentId: "sc-ac4e0f43-3"
})(_templateObject4(), function(param) {
    var size = param.size;
    return size;
}, function(param) {
    var size = param.size;
    return size;
});
var DEFAULT_PROPS = {
    disableImageShape: false,
    alt: "",
    shape: SHAPES.CIRCLE,
    size: 42
};
var Avatar = function Avatar(param) {
    var _alt = param.alt, alt = _alt === void 0 ? DEFAULT_PROPS.alt : _alt, bgColor = param.bgColor, brightness = param.brightness, children = param.children, className = param.className, disableImageShape = param.disableImageShape, icon = param.icon, imageScaleDown = param.imageScaleDown, imageDataTestId = param.imageDataTestId, onClick = param.onClick, _shape = param.shape, shape = _shape === void 0 ? DEFAULT_PROPS.shape : _shape, _size = param.size, size = _size === void 0 ? DEFAULT_PROPS.size : _size, src = param.src, text = param.text, NextImage = param.NextImage;
    var innerContent = (0,react.useMemo)(function() {
        if (src) {
            return NextImage ? /*#__PURE__*/ (0,jsx_runtime.jsx)(NextImageWrapper, {
                size: size,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NextImage, {
                    src: src,
                    objectFit: "cover",
                    sizes: "".concat(2 * size, "px"),
                    layout: "fill"
                })
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                alt: alt,
                brightness: brightness,
                "data-testid": imageDataTestId,
                disableImageShape: disableImageShape,
                imagePadding: disableImageShape ? "8px" : "5px",
                imageScaleDown: imageScaleDown,
                shape: shape,
                src: src
            });
        }
        if (icon) {
            return icon;
        }
        return text;
    }, [
        NextImage,
        alt,
        brightness,
        disableImageShape,
        icon,
        imageDataTestId,
        imageScaleDown,
        shape,
        size,
        src,
        text, 
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrap, {
        bgColor: bgColor,
        className: className,
        hasImage: !!src,
        onClick: onClick,
        shape: shape,
        size: size,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(InnerCircle, {
                shape: shape,
                children: innerContent
            }),
            children
        ]
    });
};
Avatar.propTypes = {
    brightness: function brightness(props, propName, componentName) {
        return numberInRange({
            props: props,
            propName: propName,
            componentName: componentName,
            isRequired: false,
            rangeStart: 0,
            rangeEnd: 1
        });
    }
};
Avatar.defaultProps = DEFAULT_PROPS;
/* harmony default export */ var components_Avatar = (Avatar);


/***/ }),

/***/ 92776:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(43119);
/* harmony import */ var polished__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(95494);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(50959);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(61258);
/* harmony import */ var _components_ButtonBase__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(64011);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	color: ",
        ";\n	font-size: inherit;\n	text-decoration: ",
        ";\n	cursor: pointer;\n\n	margin-left: ",
        ";\n\n	&:hover {\n		color: ",
        ";\n	}\n\n	&:focus-visible {\n		box-shadow: rgb(192 210 251) 0px 0px 0px 3px;\n	}\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var DEFAULT_PROPS = {
    color: "default",
    leftGutter: false,
    underline: true
};
// Default styles for links that occur in body text
var LinkBody = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(_components_ButtonBase__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z).attrs(function(param) {
    var color = param.color, leftGutter = param.leftGutter, underline = param.underline;
    return {
        color: color !== null && color !== void 0 ? color : DEFAULT_PROPS.color,
        leftGutter: leftGutter !== null && leftGutter !== void 0 ? leftGutter : DEFAULT_PROPS.leftGutter,
        underline: underline !== null && underline !== void 0 ? underline : DEFAULT_PROPS.underline
    };
}).withConfig({
    componentId: "sc-92e91841-0"
}).withConfig({
    componentId: "sc-46486c18-0"
})(_templateObject(), function(props) {
    return ({
        default: props.theme.colors.primary.dark,
        primaryLight: props.theme.colors.primary.light,
        onPrimary: props.theme.colors.primary.contrastText,
        white: props.theme.colors.white
    })[props.color];
}, function(props) {
    return props.underline ? "underline" : "none";
}, function(param) {
    var leftGutter = param.leftGutter;
    return leftGutter ? "4px" : "0";
}, function(props) {
    return ({
        default: (0,polished__WEBPACK_IMPORTED_MODULE_1__.lighten)(0.1, props.theme.colors.primary.dark),
        primaryLight: (0,polished__WEBPACK_IMPORTED_MODULE_1__.lighten)(0.1, props.theme.colors.primary.light),
        onPrimary: (0,polished__WEBPACK_IMPORTED_MODULE_1__.darken)(0.1, props.theme.colors.primary.contrastText),
        white: (0,polished__WEBPACK_IMPORTED_MODULE_1__.darken)(0.1, props.theme.colors.white)
    })[props.color];
});
LinkBody.defaultProps = DEFAULT_PROPS;
/* harmony default export */ __webpack_exports__["Z"] = (/*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.memo(LinkBody));


/***/ }),

/***/ 20080:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ _dynamic_slug_; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(72006);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(4405);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(11527);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.3.1_gy3t2662bfefxvvyatkvfs3nqm/node_modules/next/image.js
var next_image = __webpack_require__(19020);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(77637);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./workspaces/packages/component-library/src/index.ts + 24 modules
var src = __webpack_require__(34797);
// EXTERNAL MODULE: ./workspaces/app/static/main/src/components/Avatar/index.tsx + 1 modules
var Avatar = __webpack_require__(59249);
// EXTERNAL MODULE: ./workspaces/app/static/main/src/components/FullscreenVideoModal/index.js
var FullscreenVideoModal = __webpack_require__(12941);
// EXTERNAL MODULE: ./workspaces/app/static/main/src/components/Marketing/index.ts + 38 modules
var Marketing = __webpack_require__(79593);
// EXTERNAL MODULE: ./workspaces/app/static/main/src/components/LinkBodyV2/index.tsx
var LinkBodyV2 = __webpack_require__(84573);
// EXTERNAL MODULE: ./workspaces/app/static/main/src/services/analytics/index.ts + 3 modules
var analytics = __webpack_require__(2487);
// EXTERNAL MODULE: ./workspaces/app/static/main/src/components/ButtonIcon/index.tsx
var ButtonIcon = __webpack_require__(79962);
// EXTERNAL MODULE: ./workspaces/app/static/main/src/components/MaterialIcons/PlayCircleOutline.tsx
var PlayCircleOutline = __webpack_require__(44946);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(43119);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.1.1_7i5myeigehqah43i5u7wbekgba/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(61258);
// EXTERNAL MODULE: ./workspaces/app/static/main/src/components/Button/index.tsx + 1 modules
var Button = __webpack_require__(5226);
// EXTERNAL MODULE: ./workspaces/app/static/main/src/components/Text/index.tsx
var Text = __webpack_require__(79828);
;// CONCATENATED MODULE: ./workspaces/app/static/main/src/components/Marketing/components/WatchButton/WatchButton.styles.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	margin-top: 4px;\n	padding: 4px 3px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	font-weight: 400;\n	font-size: 1.4rem;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}



var StyledButton = (0,styled_components_browser_esm/* default */.ZP)(Button/* default */.Z).withConfig({
    componentId: "sc-b41343bb-0"
}).withConfig({
    componentId: "sc-ef995b81-0"
})(_templateObject());
var StyledButtonText = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.ZP).withConfig({
    componentId: "sc-b41343bb-1"
}).withConfig({
    componentId: "sc-ef995b81-1"
})(_templateObject1());

;// CONCATENATED MODULE: ./workspaces/app/static/main/src/components/Marketing/components/WatchButton/index.tsx





var WatchButton = function WatchButton(param) {
    var label = param.label, onClick = param.onClick;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledButton, {
        color: "grey",
        onClick: onClick,
        size: "small",
        variant: "text",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonIcon/* default */.Z, {
                size: 17,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PlayCircleOutline/* default */.Z, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledButtonText, {
                variant: "button",
                children: label
            })
        ]
    });
};
/* harmony default export */ var components_WatchButton = (WatchButton);

;// CONCATENATED MODULE: ./workspaces/app/static/main/src/ssrAdapter/templates/LandingPageTemplate.styles.ts

function LandingPageTemplate_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    padding: 112px 0;\n  "
    ]);
    LandingPageTemplate_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function LandingPageTemplate_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	width: 100%;\n	padding: 64px 0;\n	",
        "\n"
    ]);
    LandingPageTemplate_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}


var media = src/* mixins.media */.tA.BC;
var TestimonialWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-861766d2-0"
}).withConfig({
    componentId: "sc-6ddfbf29-0"
})(LandingPageTemplate_styles_templateObject1(), media.large(LandingPageTemplate_styles_templateObject()));

;// CONCATENATED MODULE: ./workspaces/app/static/main/src/ssrAdapter/templates/LandingPageTemplate.tsx













var mediaQueries = src/* mixins.mediaQueries */.tA.w5;
var MarketingLink = function MarketingLink(_param) /*#__PURE__*/ {
    var children = _param.children, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "children"
    ]);
    return (0,jsx_runtime.jsx)(LinkBodyV2/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, rest), {
        newTab: rest.href.startsWith("http://") || rest.href.startsWith("https://"),
        children: children
    }));
};
var getMarkdownComponents = function getMarkdownComponents(color) {
    return {
        a: function a(props) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(MarketingLink, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
                color: color
            }));
        },
        p: function p(props) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Marketing/* ResponsiveText */.lz, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
                color: color,
                variant: "body"
            }));
        }
    };
};
var contentMapper = function contentMapper(param) {
    var content = param.content, index = param.index, NextImage = param.NextImage, openVideoModal = param.openVideoModal;
    switch(content.type){
        case "landingPageHeader":
            {
                var props = {
                    title: content.title
                };
                if (content.showAuthForm) {
                    props.cta = /*#__PURE__*/ (0,jsx_runtime.jsx)(Marketing/* Signup */.Al, {});
                }
                if (content.subtitle) {
                    props.subtitle = /*#__PURE__*/ (0,jsx_runtime.jsx)(src/* MarkDown */.sd, {
                        components: getMarkdownComponents(),
                        content: content.subtitle
                    }, "".concat(content.type, "-").concat(index, "-0-subtitle"));
                }
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Marketing/* Header */.h4, (0,_object_spread/* default */.Z)({}, props), "".concat(content.type, "-").concat(index));
            }
        case "landingPageHighlight":
            {
                var props1 = {
                    title: content.title,
                    body: content.subtitle,
                    cta: {
                        url: content.linkUrl,
                        title: content.linkTitle
                    }
                };
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Marketing/* Highlight */.y$, (0,_object_spread/* default */.Z)({}, props1), "".concat(content.type, "-").concat(index));
            }
        case "landingPageTextAndMedia":
            {
                var props2 = {
                    header: content.title,
                    subtitle: content.subtitle && /*#__PURE__*/ (0,jsx_runtime.jsx)(src/* MarkDown */.sd, {
                        components: getMarkdownComponents(),
                        content: content.subtitle
                    }),
                    color: content.backgroundColor,
                    reverse: content.textFirst
                };
                if (content.media) {
                    if (content.media.type === "responsiveImage") {
                        var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7;
                        var aspectRatio = (((ref = content.media) === null || ref === void 0 ? void 0 : (ref1 = ref.image) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.dimensions) === null || ref2 === void 0 ? void 0 : ref2.width) || 1) / (((ref3 = content.media) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.image) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.dimensions) === null || ref5 === void 0 ? void 0 : ref5.height) || 1);
                        props2.image = /*#__PURE__*/ (0,jsx_runtime.jsx)(Marketing/* ContainerImage640x560 */.wx, {
                            aspectRatio: aspectRatio,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NextImage, {
                                alt: ((ref6 = content.media.image) === null || ref6 === void 0 ? void 0 : ref6.description) || "",
                                src: (ref7 = content.media.image) === null || ref7 === void 0 ? void 0 : ref7.url,
                                layout: "fill",
                                sizes: "".concat(mediaQueries.belowLarge, " 100vw, 50vw")
                            })
                        });
                    // TODO: support smallImage
                    }
                    if (content.media.type === "responsiveVideo") {
                        var ref8;
                        props2.image = /*#__PURE__*/ (0,jsx_runtime.jsx)(Marketing/* Video640x560 */.pm, {
                            autoPlay: true,
                            loop: true,
                            muted: true,
                            playsInline: true,
                            src: (ref8 = content.media.video) === null || ref8 === void 0 ? void 0 : ref8.url,
                            poster: content.media.poster
                        });
                    // TODO: support smallVideo
                    }
                }
                if (content.quote) {
                    var ref9;
                    props2.name = content.quote.name;
                    props2.role = content.quote.jobTitle;
                    props2.quote = content.quote.quote;
                    props2.avatar = /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                        src: (ref9 = content.quote.image) === null || ref9 === void 0 ? void 0 : ref9.url,
                        NextImage: NextImage
                    });
                }
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Marketing/* ImageBlock */.r8, (0,_object_spread/* default */.Z)({}, props2), "".concat(content.type, "-").concat(index));
            }
        case "responsiveImage":
            {
                var ref10;
                var props3 = {
                    NextImage: NextImage
                };
                if (content.image) {
                    var ref11, ref12, ref13, ref14;
                    props3.largeImage = {
                        src: content.image.url,
                        height: (ref11 = content.image.dimensions) === null || ref11 === void 0 ? void 0 : ref11.height,
                        width: (ref12 = content.image.dimensions) === null || ref12 === void 0 ? void 0 : ref12.width,
                        aspectRatio: (((ref13 = content.image.dimensions) === null || ref13 === void 0 ? void 0 : ref13.width) || 1) / (((ref14 = content.image.dimensions) === null || ref14 === void 0 ? void 0 : ref14.height) || 1)
                    };
                }
                if (content.smallImage) {
                    var ref15, ref16, ref17, ref18;
                    props3.smallImage = {
                        src: content.smallImage.url,
                        height: (ref15 = content.smallImage.dimensions) === null || ref15 === void 0 ? void 0 : ref15.height,
                        width: (ref16 = content.smallImage.dimensions) === null || ref16 === void 0 ? void 0 : ref16.width,
                        aspectRatio: (((ref17 = content.smallImage.dimensions) === null || ref17 === void 0 ? void 0 : ref17.width) || 1) / (((ref18 = content.smallImage.dimensions) === null || ref18 === void 0 ? void 0 : ref18.height) || 1)
                    };
                }
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Marketing/* HeroImage */.ZG, (0,_object_spread/* default */.Z)({
                    alt: (ref10 = content.image) === null || ref10 === void 0 ? void 0 : ref10.description
                }, props3), "".concat(content.type, "-").concat(index));
            }
        case "faqs":
            {
                var components = {
                    a: Marketing/* FaqBlockLink */.Y0,
                    img: function img(param) {
                        var src = param.src, alt = param.alt;
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Marketing/* FaqBlockImage */.gf, {
                            src: src,
                            alt: alt,
                            NextImage: NextImage
                        });
                    },
                    li: Marketing/* FaqBlockLi */.j8,
                    ol: Marketing/* FaqBlockOl */.pN,
                    p: Marketing/* FaqBlockText */.cz,
                    ul: Marketing/* FaqBlockUl */.kI
                };
                var props4 = {
                    header: content.title,
                    faqList: content.faqs ? content.faqs.map(function(faq) {
                        return {
                            question: faq.question,
                            answer: faq.answer ? /*#__PURE__*/ (0,jsx_runtime.jsx)(src/* MarkDown */.sd, {
                                components: components,
                                content: faq.answer
                            }) : null
                        };
                    }) : []
                };
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Marketing/* FaqBlock */.rf, (0,_object_spread/* default */.Z)({}, props4), "".concat(content.type, "-").concat(index));
            }
        case "landingPageCtaRow":
            {
                var props5 = {
                    title: content.title,
                    subtitle2: content.subtitle && /*#__PURE__*/ (0,jsx_runtime.jsx)(src/* MarkDown */.sd, {
                        components: getMarkdownComponents("white"),
                        content: content.subtitle
                    }),
                    body2: content.body && /*#__PURE__*/ (0,jsx_runtime.jsx)(src/* MarkDown */.sd, {
                        components: getMarkdownComponents("white"),
                        content: content.body
                    })
                };
                if (content.showAuthForm) {
                    props5.cta = /*#__PURE__*/ (0,jsx_runtime.jsx)(Marketing/* Signup */.Al, {});
                }
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Marketing/* CTARow */.Ky, (0,_object_spread/* default */.Z)({}, props5), "".concat(content.type, "-").concat(index));
            }
        case "quote":
            {
                var ref19, ref20;
                var props6 = (0,_object_spread/* default */.Z)({
                    altText: content.name,
                    quote: content.quote,
                    name: content.name,
                    role: content.jobTitle,
                    imgWebpSrc: (ref19 = content.image) === null || ref19 === void 0 ? void 0 : ref19.url,
                    imgFallbackSrc: (ref20 = content.image) === null || ref20 === void 0 ? void 0 : ref20.url
                }, content.embedYoutubeVideoId && content.embedLinkText ? {
                    watchButton: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_WatchButton, {
                        label: content.embedLinkText,
                        onClick: function onClick() {
                            return openVideoModal(content.embedYoutubeVideoId);
                        }
                    })
                } : {});
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(TestimonialWrapper, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Marketing/* Testimonial */.gc, (0,_object_spread/* default */.Z)({
                        NextImage: NextImage
                    }, props6))
                }, "".concat(content.type, "-").concat(index));
            }
        case "usp":
            {
                var props7 = {
                    title: content.title,
                    backgroundColor: content.backgroundColor,
                    cards: content.cards
                };
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Marketing/* Usp */.Dy, (0,_object_spread/* default */.Z)({
                    NextImage: NextImage
                }, props7), "".concat(content.type, "-").concat(index));
            }
        default:
            return null;
    }
};
var mapper = function mapper(param) {
    var content = param.content, NextImage = param.NextImage, openVideoModal = param.openVideoModal;
    return content === null || content === void 0 ? void 0 : content.map(function(eachContent, index) {
        return contentMapper({
            content: eachContent,
            index: index,
            NextImage: NextImage,
            openVideoModal: openVideoModal
        });
    });
};
var LandingPageTemplate = function LandingPageTemplate(param) {
    var data = param.data, NextImage = param.NextImage;
    var ref = (0,react.useState)(undefined), videoId = ref[0], setVideoId = ref[1];
    var openVideoModal = (0,react.useCallback)(function(id) {
        return setVideoId(id);
    }, []);
    var closeVideoModal = (0,react.useCallback)(function() {
        return setVideoId(undefined);
    }, []);
    (0,react.useEffect)(function() {
        analytics/* default.page */.ZP.page(analytics/* default.events.category.MARKETING */.ZP.events.category.MARKETING, data.title);
    }, [
        data.title
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            mapper({
                content: data.content,
                NextImage: NextImage,
                openVideoModal: openVideoModal
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FullscreenVideoModal/* default */.Z, {
                isOpen: !!videoId,
                onRequestClose: closeVideoModal,
                youtubeVideoId: videoId
            })
        ]
    });
};
/* harmony default export */ var templates_LandingPageTemplate = (LandingPageTemplate);

;// CONCATENATED MODULE: ./workspaces/app/static/main/src/ssrAdapter/index.js
// Landing template

/* harmony default export */ var ssrAdapter = (templates_LandingPageTemplate);

// EXTERNAL MODULE: ./node_modules/.pnpm/prop-types@15.7.2/node_modules/prop-types/index.js
var prop_types = __webpack_require__(19036);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-redux@8.1.2_ypdvb6du3tmuwvd75cbb5hw34i/node_modules/react-redux/es/index.js + 21 modules
var es = __webpack_require__(98993);
// EXTERNAL MODULE: ./workspaces/app/static/main/src/services/signup/index.js + 3 modules
var signup = __webpack_require__(43570);
// EXTERNAL MODULE: ./workspaces/app/static/main/src/services/utils/hooks/index.ts + 1 modules
var hooks = __webpack_require__(1964);
// EXTERNAL MODULE: ./workspaces/app/static/main/src/templates/LandingV2/index.tsx + 3 modules
var LandingV2 = __webpack_require__(42272);
// EXTERNAL MODULE: ./workspaces/app/static/main/src/components/usePricing/index.ts + 3 modules
var usePricing = __webpack_require__(90992);
// EXTERNAL MODULE: ./workspaces/app/static/main/src/components/Translation/index.js + 23 modules
var Translation = __webpack_require__(80055);
;// CONCATENATED MODULE: ./workspaces/app/static/main/src/scenes/Friends/templates/FriendLandingTemplate/index.js









var FriendLandingTemplate = function FriendLandingTemplate(param) {
    var image = param.image, name = param.name, referrerClick = param.referrerClick, referrerId = param.referrerId;
    var referralPricing = (0,usePricing/* default */.Z)().referralPricing;
    // Save that user signed up through this page
    (0,hooks/* useMount */.b6)(function() {
        referrerClick({
            referrer: referrerId,
            referrerType: "affiliate"
        });
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(LandingV2/* default */.Z, {
        heading: /*#__PURE__*/ (0,jsx_runtime.jsx)(Translation/* Translation */.Wb, {
            tid: "landing.title"
        }),
        recommendedBy: {
            image: image,
            text: /*#__PURE__*/ (0,jsx_runtime.jsx)(Translation/* Translation */.Wb, {
                tid: "landing.partners.referrerDescription",
                values: {
                    name: name
                },
                components: {
                    creditAmount: /*#__PURE__*/ (0,jsx_runtime.jsx)(Translation/* LocalizedCurrency */.bc, {
                        value: referralPricing.referredCredit,
                        minimumFractionDigits: 0
                    })
                }
            })
        },
        subHeading: /*#__PURE__*/ (0,jsx_runtime.jsx)(Translation/* Translation */.Wb, {
            tid: "landing.subtitle.v2"
        })
    });
};
FriendLandingTemplate.propTypes = {
    image: prop_types_default().oneOfType([
        (prop_types_default()).string,
        (prop_types_default()).object
    ]).isRequired,
    name: (prop_types_default()).string.isRequired,
    referrerClick: (prop_types_default()).func.isRequired,
    referrerId: (prop_types_default()).string.isRequired
};
var mapDispatchToProps = {
    referrerClick: signup/* signupActions.referrerClick */.FA.referrerClick
};
/* harmony default export */ var templates_FriendLandingTemplate = ((0,es/* connect */.$j)(null, mapDispatchToProps)(FriendLandingTemplate));

;// CONCATENATED MODULE: ./workspaces/app/static/main/src/ssrAdapter/templates/FriendLandingPageTemplate.tsx

/* harmony default export */ var FriendLandingPageTemplate = (templates_FriendLandingTemplate);

// EXTERNAL MODULE: ./workspaces/app/static/main/src/components/LinkBody/index.tsx
var LinkBody = __webpack_require__(92776);
// EXTERNAL MODULE: ./workspaces/app/static/main/src/services/analytics/usePageTrack.js
var usePageTrack = __webpack_require__(55804);
;// CONCATENATED MODULE: ./workspaces/app/static/main/src/scenes/Partners/templates/PartnerLandingTemplate/index.js











var PartnerLandingTemplate = function PartnerLandingTemplate(param) {
    var image = param.image, name = param.name, preTitle = param.preTitle, preTitleKey = param.preTitleKey, partner = param.partner, partnerClick = param.partnerClick, partnerDescription = param.partnerDescription, partnerDescriptionKey = param.partnerDescriptionKey, partnerNameKey = param.partnerNameKey;
    var partnersDescription = (0,Translation/* useTranslation */.$G)("landing.partners.description", {
        name: name
    });
    (0,usePageTrack/* default */.Z)({
        name: analytics/* default.events.PARTNER */.ZP.events.PARTNER,
        category: analytics/* default.events.category.MARKETING */.ZP.events.category.MARKETING,
        partnerName: name
    });
    // Save that user signed up through this page
    (0,hooks/* useMount */.b6)(function() {
        partnerClick({
            partner: partner,
            referrerType: "partner"
        });
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(LandingV2/* default */.Z, {
        preTitle: preTitleKey ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Translation/* Translation */.Wb, {
            tid: preTitleKey
        }) : preTitle,
        heading: /*#__PURE__*/ (0,jsx_runtime.jsx)(Translation/* Translation */.Wb, {
            tid: "landing.title"
        }),
        recommendedBy: {
            image: image,
            text: partnerDescriptionKey ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Translation/* Translation */.Wb, {
                tid: partnerDescriptionKey,
                components: {
                    link: /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkBody/* default */.Z, {
                        to: "/contact"
                    }),
                    name: /*#__PURE__*/ (0,jsx_runtime.jsx)(Translation/* Translation */.Wb, {
                        tid: partnerNameKey
                    })
                }
            }) : partnerDescription || partnersDescription
        },
        subHeading: /*#__PURE__*/ (0,jsx_runtime.jsx)(Translation/* Translation */.Wb, {
            tid: "landing.subtitle.v2"
        })
    });
};
PartnerLandingTemplate.propTypes = {
    image: prop_types_default().oneOfType([
        (prop_types_default()).string,
        (prop_types_default()).object
    ]),
    name: (prop_types_default()).string.isRequired,
    preTitle: (prop_types_default()).node,
    preTitleKey: (prop_types_default()).string,
    partner: (prop_types_default()).string.isRequired,
    partnerClick: (prop_types_default()).func.isRequired,
    partnerDescription: (prop_types_default()).node,
    partnerDescriptionKey: (prop_types_default()).string,
    partnerNameKey: (prop_types_default()).string
};
var PartnerLandingTemplate_mapDispatchToProps = {
    partnerClick: signup/* signupActions.partnerClick */.FA.partnerClick
};
/* harmony default export */ var templates_PartnerLandingTemplate = ((0,es/* connect */.$j)(null, PartnerLandingTemplate_mapDispatchToProps)(PartnerLandingTemplate));

;// CONCATENATED MODULE: ./workspaces/app/static/main/src/ssrAdapter/templates/PartnerLandingPageTemplate.tsx

/* harmony default export */ var PartnerLandingPageTemplate = (templates_PartnerLandingTemplate);

// EXTERNAL MODULE: ./src/components/templates/MarketingTemplate/index.ts + 7 modules
var MarketingTemplate = __webpack_require__(90539);
;// CONCATENATED MODULE: ./src/pages/[...dynamic-slug].tsx








var LandingPage = function(param) {
    var data = param.data, featureFlags = param.featureFlags, navigation = param.navigation, pageType = param.pageType, user = param.user;
    if (pageType === "affiliatePage") {
        var image = data.image, name = data.name, referrerId = data.referrerId;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(MarketingTemplate/* default */.Z, {
            featureFlags: featureFlags,
            navigation: navigation,
            user: user,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FriendLandingPageTemplate, {
                image: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    alt: name,
                    height: 50,
                    src: image,
                    width: 50
                }),
                name: name,
                referrerId: referrerId
            })
        });
    }
    if (pageType === "partnerPage") {
        var image1 = data.image, name1 = data.name;
        var isIHeart = name1 === "IHeart";
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(MarketingTemplate/* default */.Z, {
            featureFlags: featureFlags,
            navigation: navigation,
            user: user,
            children: [
                isIHeart && // eslint-disable-next-line @next/next/no-img-element, jsx-a11y/alt-text
                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    src: "https://arttrk.com/pixel/?ad_log=referer&action=content&pixid=dfd0fbd9-e7bd-4f9b-83ca-25f7bee979d8",
                    width: "1",
                    height: "1"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(PartnerLandingPageTemplate, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, data), {
                    image: image1 ? /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        alt: name1,
                        height: 50,
                        src: image1,
                        width: 50
                    }) : undefined
                }))
            ]
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(MarketingTemplate/* default */.Z, {
        featureFlags: featureFlags,
        activePage: "/".concat(data.urlPath),
        navigation: navigation,
        user: user,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ssrAdapter, {
            NextImage: (image_default()),
            data: data
        })
    });
};
var __N_SSP = true;
/* harmony default export */ var _dynamic_slug_ = (LandingPage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [8078,5951,58,8869,5839,9020,9779,2218,5539,2682,5646,7885,903,7994,539,7401,253,446,9774,2888,179], function() { return __webpack_exec__(57966); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);